module.exports = __webpack_public_path__ + "static/media/uz.ca892343.svg";